function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.06089 13.3302V20H12.9396V13.3302H15.2931V8.03744C15.2931 6.41666 13.9745 5.09806 12.3537 5.09806H11.6496L11.596 4.85092C11.9233 4.49577 12.1229 4.0429 12.1622 3.5574L12.2524 2.44224C12.3841 1.15368 11.254 -0.0289839 10.0003 0.000507525C8.70694 -0.029687 7.61709 1.19821 7.74818 2.4422L7.83845 3.5574C7.87774 4.04286 8.07735 4.49574 8.40461 4.85092L8.35105 5.09806H7.64689C6.02612 5.09806 4.70752 6.41666 4.70752 8.03744V13.3302H7.06089ZM11.0844 2.34779L10.9941 3.46291C10.9525 3.97696 10.516 4.37965 10.0003 4.37965C9.48458 4.37965 9.04799 3.97696 9.00643 3.46291L8.91615 2.34775C8.85237 1.70945 9.41989 1.15872 10.0003 1.17239C10.5807 1.15872 11.1482 1.70941 11.0844 2.34779ZM8.23274 7.64682H7.06089V12.1583H5.87928V8.03744C5.87928 7.06281 6.67219 6.26991 7.64681 6.26991H9.2961L9.4663 5.48454C9.63926 5.52836 9.81836 5.55145 10.0003 5.55145C10.1822 5.55145 10.3612 5.52836 10.5342 5.48454L10.7044 6.26991H12.3537C13.3283 6.26991 14.1212 7.06281 14.1212 8.03744V12.1583H12.9396V7.64682H11.7678V18.8282H10.5862V12.3537H9.41434V18.8282H8.23274V7.64682Z",
  fill: "#23335B"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M2.44417 7.58897V8.52211L3.40707 8.25841L3.7166 9.38861L1.27233 10.058V9.12503L0.310089 9.38861L0.000488281 8.25841L2.44417 7.58897Z",
  fill: "#23335B"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M3.14559 5.07603L4.01302 5.57047L3.43265 6.58849L1.23099 5.33348L1.89074 4.67374L1.02393 4.17973L1.60422 3.16163L3.80541 4.41616L3.14559 5.07603Z",
  fill: "#23335B"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M6.20751 3.50549L4.00581 2.25048L4.66556 1.59073L3.79883 1.09676L4.37905 0.0786667L6.58039 1.33324L5.92053 1.99307L6.78789 2.48747L6.20751 3.50549Z",
  fill: "#23335B"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M1.23099 12.3136L3.43265 11.0586L4.01302 12.0766L3.14559 12.5711L3.80541 13.2309L1.60422 14.4855L1.02393 13.4674L1.89074 12.9734L1.23099 12.3136Z",
  fill: "#23335B"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M3.21968 15.9761L5.42138 14.721L6.00175 15.7391L5.1344 16.2335L5.79426 16.8933L3.59291 18.1479L3.0127 17.1298L3.87943 16.6358L3.21968 15.9761Z",
  fill: "#23335B"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M18.728 10.058L16.2837 9.38861L16.5932 8.25841L17.5561 8.52211V7.58897L19.9998 8.25841L19.6902 9.38861L18.728 9.12503V10.058Z",
  fill: "#23335B"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M18.7693 5.33348L16.5677 6.58849L15.9873 5.57047L16.8547 5.07603L16.1949 4.41616L18.3961 3.16163L18.9764 4.17973L18.1096 4.67374L18.7693 5.33348Z",
  fill: "#23335B"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M15.9945 2.25048L13.7928 3.50549L13.2124 2.48747L14.0798 1.99307L13.4199 1.33324L15.6212 0.0786667L16.2015 1.09676L15.3347 1.59073L15.9945 2.25048Z",
  fill: "#23335B"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M16.8547 12.5711L15.9873 12.0766L16.5677 11.0586L18.7693 12.3136L18.1096 12.9734L18.9764 13.4674L18.3961 14.4855L16.1949 13.2309L16.8547 12.5711Z",
  fill: "#23335B"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M14.5818 14.7223L16.7835 15.9773L16.1238 16.637L16.9905 17.131L16.4103 18.1491L14.209 16.8945L14.8688 16.2347L14.0015 15.7403L14.5818 14.7223Z",
  fill: "#23335B"
});

var SvgPain = function SvgPain(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPain, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pain.f5c47c66.svg";
export { ForwardRef as ReactComponent };